module.exports = __webpack_public_path__ + "img/_3.a2c3e382.png";